/*
 * DRIVLY-UI React Components
 * @license MIT
 */
import{createContext as o}from"react";const r=o({});export{r as SwitchLayoutGroupContext};
//# sourceMappingURL=SwitchLayoutGroupContext.js.map
